import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  SponsorOverviewFetchAction,
  SponsorOverviewFetchSuccessAction,
  sponsorOverviewSetFiltersAction,
  SponsorOverviewState,
  SponsorOverviewSummaryFetchAction,
  SponsorOverviewSummaryFetchSuccessAction,
} from './sponsorOverview.types';

const initialState: SponsorOverviewState = {
  loading: false,
  error: undefined,
  data: null,
  summary: null,
  search: '',
  filters: {
    siteId: null,
    visitId: null,
  },
};

const { actResolve, actReject, act, actEmpty } =
  makeActionCreator<SponsorOverviewState>();

export const SponsorOverviewSlice = createSlice({
  name: 'sponsorOverview',
  initialState,
  reducers: {
    fetchSponsorOverview: act<SponsorOverviewFetchAction['payload']>(
      ({ filters }) => ({
        filters,
        loading: true,
        error: undefined,
      })
    ),
    fetchSponsorOverviewSuccess:
      actResolve<SponsorOverviewFetchSuccessAction['payload']>('data'),
    fetchSponsorOverviewError: actReject(),
    fetchSponsorOverviewSummaryRequest:
      actEmpty<SponsorOverviewSummaryFetchAction['payload']>(),
    fetchSponsorOverviewSummarySuccess:
      actResolve<SponsorOverviewSummaryFetchSuccessAction['payload']>(
        'summary'
      ),
    fetchSponsorOverviewSummaryError: actReject(),
    setFilters: (state, action: sponsorOverviewSetFiltersAction) => {
      if (!action.payload.filterQuery) {
        return;
      }
      state.filters = {
        ...state.filters,
        [action.payload.filterQuery]: action.payload.filterValue,
      };
    },
    setSearch: act<string>(search => ({ search })),
    clear: state => {
      state.loading = false;
      state.error = undefined;
      state.data = null;
      state.summary = null;
      state.filters = initialState.filters;
    },
  },
});

export const actions = {
  ...SponsorOverviewSlice.actions,
};

export const useSponsorOverviewSlice = createSliceHook(
  SponsorOverviewSlice.name,
  actions
);
